import React from 'react';
import { Box, Button, withStyles } from '@material-ui/core';
import Item from './Item';

const StyledButton = withStyles(() => ({
  root: {
    backgroundColor: 'rgb(232,187,49)',
    height: '100%',
    borderRadius: 14,
    '&:hover': {
      backgroundColor: 'rgb(232,187,49)',
    },
    '&:active': {
      opacity: '.5',
    },
  },
  text: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'white',
  },
}))(Button);

const ItemBox = withStyles((theme) => ({
  root: {
    '&+&': {
      marginTop: theme.spacing(1.5),
    },
  },
}))(Box);

export default ({
  buttonColor,
  buttonText,
  emptyText,
  items,
  onButtonClick,
  onItemClick,
  selectedItemsId,
}) => (items.length === 0 ? (
  <Box>{emptyText}</Box>
) : (
  <>
    {items.map(({
      id,
      fridgeName,
      productName,
      providerName,
    }) => (
      <ItemBox key={id}>
        <Item
          id={id}
          checked={selectedItemsId.includes(id)}
          fridgeName={fridgeName}
          productName={productName}
          onClick={onItemClick}
          providerName={providerName}
        />
      </ItemBox>
    ))}
    <Box width={1} height={40} mt={5}>
      <StyledButton
        style={{ backgroundColor: buttonColor }}
        disableRipple
        disabled={!selectedItemsId.length}
        fullWidth
        onClick={onButtonClick}
      >
        {buttonText}
      </StyledButton>
    </Box>
  </>
));
